/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from '../../http/requests/auth/jwt/index.js'

import router from '@/router'

export default {
  // Login Admin
  loginAdmin ({
    commit
  }, payload) {

    return new Promise((resolve, reject) => {
      jwt.login(payload.username, payload.password)
        .then(response => {
          // If there's user data in response
          if (response.data.data) {

            // Navigate User to homepage
            router.push(router.currentRoute.query.to || '/')

            // Set accessToken
            localStorage.setItem('accessToken', response.data.data.access_token)

            // Update user details
            commit('UPDATE_USER_INFO', response.data.data, {
              root: true
            })
            // Set bearer token in axios
            commit('SET_BEARER', response.data.data.access_token)

            resolve(response)
          } else {
            reject({
              message: 'Wrong Email or Password'
            })
          }

        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // Logout Admin
  logout () {
    return new Promise((resolve, reject) => {
      jwt.logout()
        .then(() => {
          // Navigate User to login
          router.push('/login')
        })
        .catch(error => {
          reject(error)
          router.push('/login')
        })
    })
  },
  fetchAccessToken () {
    return new Promise((resolve) => {
      jwt.refreshToken().then(response => {
        resolve(response)
      })
    })
  }
}
